export default __webpack_public_path__ + "static/media/FG-Renewal-Form.92aa394e.pdf";